import { all } from "redux-saga/effects";
import { watchapprovePayment } from "./approvePayment";
import { watchclientStatement } from "./clientStatement";
import { watchInvoiceSaga } from "./invoice";
import { watchrecordPayment } from "./recordPayment";
import { watchbankDetails } from "./bank-details/index";
import { watchbankApprove } from "./bank-approve";
import { watchkycStatus } from "./kycStatus";
import { watchOutstandingBalanceSaga } from "./outstandingBalance";
//import { watchReportSaga } from "./reports";
import { watchEmailListSaga } from "./emailList";
import { watchCreditNoteSaga } from "./creditNotes";
import { watchInvoiceItemMaster } from "./invoiceItemMaster";
import { watchRentalBills } from "./rentalbills";
import { watchsupplementarybills } from "./supplementarybills";
import rootSagaReports from "../../sagas/acclgl/reports";
import { watchMemberSubscriptionInvoiceListSaga } from "./invoice/memberSubscriptionInvoiceList";
import {watchGenerateRentalInvoiceSaga} from "./generateRentalInvoice";
export default function* rootSagaacclgl(getState) {
  yield all([watchclientStatement()]);
  yield all([watchrecordPayment()]);
  yield all([watchapprovePayment()]);
  yield all([watchInvoiceSaga()]);
  yield all([watchbankDetails()]);
  yield all([watchbankApprove()]);
  yield all([watchkycStatus()]);
  yield all([watchOutstandingBalanceSaga()]);
  yield all([watchEmailListSaga()]);
  yield all([watchCreditNoteSaga()]);
  yield all([watchInvoiceItemMaster()]);
  yield all([watchRentalBills()]);
  yield all([watchsupplementarybills()]);
  yield all([watchMemberSubscriptionInvoiceListSaga()]);
  yield all([...rootSagaReports()]);
  yield all([watchGenerateRentalInvoiceSaga()]);
}
